import axiosInstance from "../../../api/axiosInstance";

let lessonPlanRequest = 0;
let lessonRequest = 0;

export default {
  namespaced: true,
  state: {
    contents: [],
    categories: [],
    contentTypes: [],
    content: {},
    tags: [],
    lessonPlans: [],
    lessonPlan: {},
    lesson: {},
  },
  actions: {
    async loadAllCurriculum({ commit }) {
      const response = await axiosInstance.get(`/lesson_plans/`);
      commit("setLessonPlans", response.data.lesson_plans);
      commit("setContentTypes", response.data.content_types);
      commit("setTags", response.data.tags);
    },
    async loadCurriculum({ commit }, id) {
      const response = await axiosInstance.get(`/cms/${id}`);
      commit("setContent", response.data);
    },
    async fetchLessonPlan({ commit }, payload) {
      const { id, preview, revisionId } = typeof payload === "object" ? payload : { id: payload };
      const request = ++lessonPlanRequest;
      commit("setLessonPlan", {});
      try {
        const response = await axiosInstance.get(`/lesson_plans/${id}`, { params: { preview: preview ? "true" : undefined, revision_id: preview ? revisionId : undefined } });
        if (request !== lessonPlanRequest) return;
        commit("setLessonPlan", response.data);
        return response;
      } catch (error) {
        return error.response;
      }
    },
    async fetchLesson({ commit }, payload) {
      const { id, preview, revisionId, lessonPlanId } = typeof payload === "object" ? payload : { id: payload };
      const request = ++lessonRequest;
      commit("setLesson", {});
      const response = await axiosInstance.get(`/lessons/${id}`, { params: { preview: preview ? "true" : undefined, revision_id: preview ? revisionId : undefined, lesson_plan_id: lessonPlanId } });
      if (request !== lessonRequest) return;
      commit("setLesson", response.data);
      return response;
    },
  },
  mutations: {
    setLessonPlans(state, data) {
      state.lessonPlans = data;
    },
    setLessonPlan(state, data) {
      state.lessonPlan = data;
    },
    setContents(state, data) {
      state.contents = data;
    },
    setContent(state, data) {
      state.content = data;
    },
    setCategories(state, data) {
      state.categories = data;
    },
    setContentTypes(state, data) {
      state.contentTypes = data;
    },
    setTags(state, data) {
      state.tags = data;
    },
    setLesson(state, data) {
      state.lesson = data;
    },
  },
  getters: {
    lessonPlans: (state) => state.lessonPlans,
    contents: (state) => state.contents,
    content: (state) => state.content,
    categories: (state) => state.categories,
    contentTypes: (state) => state.contentTypes,
    tags: (state) => state.tags,
    lessonPlan: (state) => state.lessonPlan,
    lesson: (state) => state.lesson,
  },
};
